const colors = {
  black: '#000000',
  green: '#3FB618',
  white: '#FFFFFF'
};

export default {
  colors
};